import React from 'react';
import { Pagination, Table } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import css from './PaginationBar.scss';

export default class PaginationBar extends React.Component {

  /**
   * Called on change of an active page by the Semantic Pagination component and calls the given onPageChange function
   * @param {SyntheticEvent} event - the event fired by the Pagination component when the page is changed
   * @param {Object} data - the props coming from the Pagination component
   */
  onPageChange = (event, data) => {
    // activePage count starts at 1, so subtract 1 to get correct index
    this.props.onPageChange(this.props.itemsPerPage * (data.activePage - 1));
  }

  get activePage() {
    return Math.ceil(this.props.start / this.props.itemsPerPage) + 1;
  }

  // checks if activePage is the first page
  get firstPage() {
    return this.activePage === 1;
  }

  // checks if activePage is the last page
  get lastPage() {
    return this.activePage === this.pageCount;
  }

  // the total number of pages in the pagination bar
  get pageCount() {
    return this.props.totalItems === 0 ? 0 : Math.ceil(this.props.totalItems / this.props.itemsPerPage);
  }

  render() {
    return  (
      <Table.Row>
        <Table.HeaderCell colSpan={this.props.colspan}>
          <div className={css['paging-bar']}>
            <div className={css['paging-content']}>
              <Pagination size="tiny"
                          className={css['pagination']}
                          aria-label={`${this.props.itemName} page ${this.activePage} of ${this.pageCount}`}
                          activePage={this.activePage}
                          totalPages={this.pageCount}
                          onPageChange={this.onPageChange}
                          firstItem={{content: "First", disabled: this.firstPage}}
                          prevItem={{content: "Previous", disabled: this.firstPage}}
                          nextItem={{content: "Next", disabled: this.lastPage, tabIndex: 0}}
                          lastItem={{content: "Last", disabled: this.lastPage, tabIndex: 0}} />
            </div>
          </div>
        </Table.HeaderCell>
      </Table.Row>
    );
  }

}

PaginationBar.defaultProps = {
  totalSelected: 0
};

PaginationBar.propTypes = {
  colspan: PropTypes.number.isRequired,
  itemName: PropTypes.string.isRequired,
  itemsPerPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  start: PropTypes.number.isRequired,
  totalItems: PropTypes.number.isRequired,
  totalSelected: PropTypes.number
}
